<template>
  <div>
    <p class="mt-2">
      Output goes to console
    </p>

    <div class="d-flex flex-column">
      <b-button @click="outputCurrentRecord">
        Current Record
      </b-button>
      <b-button
        class="mt-2"
        @click="outputCurrentRecordWorkflow"
      >
        Current Record workflow
      </b-button>
      <b-button
        class="mt-2"
        @click="outputCurrentUser"
      >
        Current User Roles
      </b-button>


      <b-input-group
        class="mt-3"
        prepend="Record by Uuid"
      >
        <b-form-input v-model="recordUuid" />
        <b-input-group-append>
          <b-button
            variant="info"
            :disabled="busy || recordUuid === ''"
            @click="outputRecordByUuid"
          >
            GO
          </b-button>
        </b-input-group-append>
      </b-input-group>

      <b-input-group
        class="mt-3"
        prepend="Location by Uuid"
      >
        <b-form-input v-model="locationUuid" />
        <b-input-group-append>
          <b-button
            variant="info"
            :disabled="busy || locationUuid === ''"
            @click="outputLocationByUuid"
          >
            GO
          </b-button>
        </b-input-group-append>
      </b-input-group>
    </div>

    <json-viewer
      v-if="jsonData"
      :value="jsonData"
      @keyclick="handleKeyclick"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import JsonViewer from 'vue-json-viewer'

export default {
  name: 'RealisationSidebarDebugTab',
  components: {
    JsonViewer,
  },
  props: {
    record: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      busy: false,
      recordUuid: '',
      locationUuid: '',
      jsonData: null,
    }
  },
  computed: {
    ...mapGetters('user', [
      'roleDetails',
    ]),
    ...mapGetters('chargingpoints', [
      'getChargingPointByUUID',
    ]),
    ...mapGetters('realisations', [
      'getSelectedRecord',
    ]),
    ...mapGetters('tenant', [
      'getWorkflowSpecByUuid',
    ]),
  },
  methods: {
    outputCurrentRecord() {
      console.log(this.record)
      const status = this.record.getCurrentFlowStatus()
      console.log(status)
      this.jsonData = status
    },
    outputCurrentUser() {
      console.log(this.roleDetails)
      this.jsonData = this.roleDetails
    },
    outputRecordByUuid() {
      let record = this.getSelectedRecord || {}

      console.log(record)
      this.jsonData = record
    },
    outputLocationByUuid() {
      let record = this.getChargingPointByUUID({
        uuid: this.locationUuid,
      }) || {}
      console.log(record)
      this.jsonData = record
    },
    outputCurrentRecordWorkflow() {
      console.log(
        this.getWorkflowSpecByUuid({
          uuid: this.record.flow.uuid,
        }),
      )
    },
    handleKeyclick(path) {

      console.log(path, this.jsonData)
    },
  },
}
</script>
